'use client'

import { useTranslations } from 'next-intl'
import { Result } from '@shared/components/Search/Result'
import { Stack } from '@christiankaindl/lyts'
import {
  useSearch,
  useSearchResults,
} from '@shared/components/Search/SearchProvider'
import { SearchResultBoundary } from '@shared/components/Search/SearchResultBoundary'
import Text from '../Text/Text'
import Placeholder from '../Placeholder/Placeholder'

export const SEARCH_RESULTS_LIST_ID = 'search-results-list'

export default function SearchResultsList() {
  const t = useTranslations('SearchResults')
  const isPending = useSearch((state) => state.isPending)
  const error = useSearch((state) => state.error)
  const results = useSearchResults()

  return (
    <Stack
      id={SEARCH_RESULTS_LIST_ID}
      style={{
        pointerEvents: isPending ? 'none' : undefined,
        transition: 'opacity 120ms',
        opacity: isPending ? 0.6 : undefined,
      }}
    >
      {error && (
        <Text align='center' style={{ maxWidth: 'unset' }} color='tertiary'>
          {t('errorMessage')}
        </Text>
      )}
      {!error &&
        results?.grouped_hits?.map((hit) => {
          return (
            <SearchResultBoundary
              key={hit.group_key.join()}
              context={{
                kind: 'grouped-hit',
                location: 'SearchResultsList',
                query: results.request_params?.q,
                result: hit,
              }}
            >
              <Result result={hit} />
            </SearchResultBoundary>
          )
        })}
      {!error &&
        !isPending &&
        (!results?.grouped_hits || results.grouped_hits.length === 0) && (
          <Text align='center' style={{ maxWidth: 'unset' }} color='tertiary'>
            {t('emptyText')}
          </Text>
        )}
    </Stack>
  )
}

export function SearchResultsListLoading() {
  return (
    <Stack
      style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
      }}
    >
      <Placeholder type='image' width='100%' height='7em' />
      <Placeholder type='image' width='100%' height='7em' />
      <Placeholder type='image' width='100%' height='7em' />
    </Stack>
  )
}
